// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowPopper_root__LBr70","arrow":"ArrowPopper_arrow__hnETc","pop":"ArrowPopper_pop__l8OiO"};